<template>
  <div class="free-months-benefit-notification-box">
    <img class="icon" :src="require('@/assets/subscription/discount.svg')">
    <div class="text-container">
      <div class="first-line bold">מגיעה לך הטבה בתשלום!</div>
      <div class="more">{{ description }}</div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'FreeMonthsBenefitNotificationBox',
  computed: {
    ...mapState('benefits', ['benefitType', 'benefitAmount']),
    ...mapGetters('benefits', ['BENEFIT_TYPES']),
    description() {
      return `${this.monthFreeString} ראשונים בשירות בחינם! משלמים רק מהחודש ה-${this.monthToStartPaying} לשימוש, ₪45 לחודש.`;
    },
    monthFreeString() {
      if (this.benefitAmount === 1) {
        return 'חודשיים';
      }
      return `${this.benefitAmount + 1} חודשים`;
    },
    monthToStartPaying() {
      return this.benefitAmount + 2;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~base-ui/src/scss/riseup-colors";

.free-months-benefit-notification-box {
  display: flex;
  padding: 20px 15px;
  border-radius: 8px;
  width: 100%;
  background-color: $riseup_v2_light_yellow;
  font-size: 14px;
  line-height: 1.36;

  .icon {
    width: 30px;
    height: 30px;
    margin-left: 15px;
  }

  .text-container {
    .first-line {
      margin-bottom: 5px;
    }

    .bold {
      font-weight: bold;
    }
  }
}

</style>
